module.exports = __webpack_public_path__ + "assets/images/caixa-de-sapatos_15a60c44e1dce678c825f41e9e22dffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/paralelepipedo/caixa-de-sapatos.png
// module id = 208
// module chunks = 0